import cn from "classnames";
import { Card, Container, Ratio } from "react-bootstrap";
import { Parallax } from "react-scroll-parallax";

import { Back } from "@/ui/Back";
import { Buttons } from "@/ui/Buttons";
import { Hexagon } from "@/ui/Hexagon";
import classes from "./styles.module.scss";

export default function ({
  className,
  title,
  image,
  logo,
  EditableHtml,
  EditableImage,
  theme = "light",
  buttons = [{ label: `View jobs at ${title}`, url: "#jobs", variant: "blue" }],
}) {
  return (
    <Card className={cn(className, classes.FeaturedClientHero)} data-bs-theme={theme}>
      <Parallax easing="easeInBack" translateY={[0, 50]} className="parallax">
        <Card.Img as={Ratio} aspectRatio={34}>
          <EditableImage path="image" src={image ?? "/assets/default_hero.webp"} size="1920x547" />
        </Card.Img>
      </Parallax>
      <Card.ImgOverlay className="d-flex flex-column justify-content-center pt-6 pb-4 pb-lg-5">
        <Container fluid="md" className="pt-5 pb-md-5">
          <Back className="mb-lg-5" href="/about-us/featured-clients/">
            Back to Featured Clients
          </Back>
        </Container>
        <Container className="mw-xl">
          <div className="d-flex justify-content-between">
            <div>
              <strong className="text-blue">Featured Client</strong>
              <div className="mb-3">
                <Card.Title as={EditableHtml} path="title" tag="h1">
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </Card.Title>
              </div>
              {buttons && <Buttons buttons={buttons} className="gap-3" />}
            </div>
            <div>
              <Hexagon>
                <div className="d-flex justify-content-center align-items-center p-4">
                  <img src={logo} alt="" />
                </div>
              </Hexagon>
            </div>
          </div>
        </Container>
      </Card.ImgOverlay>
    </Card>
  );
}
